import logoSVG from '../../../assets/elora_logo.svg';
import { useTranslation } from '../../../hooks/useTranslation';
import StyledLogo from './StyledLogo';

const Logo = (): JSX.Element => {
  const { t } = useTranslation();
  return <StyledLogo src={logoSVG} alt={t('Elora logo')} />;
};

export default Logo;
